import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerSettingsPeriodRulesFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsPeriodRulesForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerSettingsPeriodRulesFormSchema,
  getDefaultCSSchedulerPeriodRulesValues,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import { useCSSchedulePeriodRulesQuery, useCSSetSchedulePeriodRulesMutation } from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsPeriodRulesTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data } = useCSSchedulePeriodRulesQuery();
  const { mutateAsync, isPending } = useCSSetSchedulePeriodRulesMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsRulesWrite);

  const handleSubmit = async (formData: CSSchedulerSettingsPeriodRulesFormType) => {
    try {
      await mutateAsync(formData);
      toast.success(`Scheduler Rules updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex flex-col">
      {data ? (
        <Form<CSSchedulerSettingsPeriodRulesFormType>
          defaultValues={getDefaultCSSchedulerPeriodRulesValues(data)}
          schema={csSchedulerSettingsPeriodRulesFormSchema}
          onSubmit={handleSubmit}
        >
          <CSSchedulerSettingsPeriodRulesForm isReadOnly={!hasWritePermissions} />
          <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
        </Form>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
